<section>
  <h3 class="mb-2">Discover</h3>
  <div class="row g-4">
    <p>Find the tools, learning, and updates you need to keep building securely.</p>
    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card-borderless class="w-100 h-100">
        <backstage-color-bg-icon card-icon iconName="download" color="blue" [height]="2" [width]="2"/>
        <span card-title>Downloads</span>
        <span card-description>Access product software, tools, and release downloads.</span>
        <a card-footer class="btn btn-outline-primary rounded-5" [href]="downloadsUrl">Browse downloads</a>
      </backstage-card-borderless>
    </div>

    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card-borderless class="w-100 h-100">
        <backstage-color-bg-icon card-icon iconName="school" color="purple" [height]="2" [width]="2"/>
        <span card-title>Training</span>
        <span card-description>Build product expertise with learning resources and training.</span>
        <a card-footer class="btn btn-outline-primary rounded-5" [href]="trainingUrl">Explore training</a>
      </backstage-card-borderless>
    </div>

    @if ([ 'customer', 'contractor', 'internal' ] | hasRole) {
      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card-borderless class="w-100 h-100">
          <backstage-color-bg-icon card-icon iconName="cloud" color="cyan" [height]="2" [width]="2"/>
          <span card-title>Cloud Storage</span>
          <span card-description>Access shared files available to your account.</span>
          <a card-footer class="btn btn-outline-primary rounded-5" href="/cloudstorage">Open Cloud Storage</a>
        </backstage-card-borderless>
      </div>
    }

    @if ([ 'customer', 'internal', 'partner' ] | hasRole) {
      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card-borderless class="w-100 h-100">
          <backstage-color-bg-icon card-icon iconName="receipt_long" color="green" [height]="2" [width]="2"/>
          <span card-title>Subscriptions</span>
          <span card-description>Review your subscriptions, services, and account entitlements.</span>
          <a card-footer class="btn btn-outline-primary rounded-5" href="https://backstage.pingidentity.com/account/subscriptions">View subscriptions</a>
        </backstage-card-borderless>
      </div>
    }
  </div>
</section>
